import Vue from 'vue';
import moment from  'moment-timezone';
import config from './constants/config';

Vue.filter('capitalize', (word) => {
  return `${word[0].toUpperCase()}${word.slice(1)}`;
});

Vue.filter('prettyDate', (date) => {
  let dateMoment = moment(date);
  if (dateMoment.isValid()) {
    return dateMoment.tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format(config.PRETTY_DATE_FORMAT);
  }
  return '-';
});

Vue.filter('prettyDateTime', (date) => {
  if (date === null) return '';
  return moment(date).tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format(config.PRETTY_DATE_TIME_FORMAT);
});

Vue.filter('poolName', (pool) => {
  if (pool && pool.license_type && pool.license_type.product) {
    return `${pool.license_type.product.name}: ${pool.license_type.name}`;
  }
  return "";
});

Vue.filter('pluralise', (value, count) => {
  return count != 1 ? `${value}s` : `${value}`
});
